<template>
  <v-card transition="fade-transition" origin="center center" class="check-card">
    <v-card-title class="title white--text pl-2 pt-2 pb-0" :class="check.color" v-show="showStoreName">
      <span class="body-1 font-weight-bold">
        {{ check.store_name }}
      </span>
    </v-card-title>
    <v-card-title v-if="check.sale_type > 4" class="title white--text pl-1 py-0" :class="check.color">
      <v-chip label v-if="check.sale_type > 4" color="red" class="white--text">
        <span class="font-weight-black subheading">{{ platform }}</span>
        <span v-if="check.vendor_id" class="headline font-weight-bold">&nbsp;:&nbsp;{{ check.vendor_id.slice(-4)
          }}</span>
      </v-chip>
    </v-card-title>

    <v-card-title class="title white--text pl-1 py-0" :class="check.color">
      <div class="sale-view-activator" @click="showCheckDetails = true">
        <v-icon :color="check.service_type === '4' ? 'error' : 'white'" class="pl-1">{{ check.icon }}</v-icon>
        <!-- <sup class="caption">({{ lineItems.length }})</sup> -->
        <span class="mx-1" style="font-size: 16px">
          <strong>
            #{{ check.check_number }}
            <span v-if="check.service_type === 3">
              /{{ check.table_name }}
            </span>
          </strong>
        </span>
        <span v-if="check.employee_name" class="body-1 font-weight-bold">
          Staff: {{ check.employee_name }}
        </span>
        <strong style="font-size: 16px; word-break: break-word" v-if="check.sale_type > 4 && check.vendor_id">
          #{{ check.vendor_id }}</strong>
      </div>
      <v-spacer></v-spacer>
      <div class="pr-3" v-if="showScrollControls">
        <v-btn icon small outline color="white" class="scroll-arrow ma-1" :disabled="!enableUpArrow"
          @click="moveTo(-scrollVal)"><v-icon>keyboard_arrow_up</v-icon></v-btn>
        <v-btn icon small outline color="white" class="scroll-arrow ma-1" :disabled="!enableDownArrow"
          @click="moveTo(scrollVal)"><v-icon>keyboard_arrow_down</v-icon></v-btn>
      </div>
      <span class="body-1 check-timer" v-if="showTime">
        <timer :date="`${check.sale_open_date}`" :time="`${check.sale_open_time}:00`" v-show="!check.fab"></timer>
      </span>
      <action-btn :item="check" :act="actOnCheck" color="white"
        class="text-xs-right check-action"></action-btn>
      <v-flex sm12 v-if="selectedItems.length" class="text-xs-center pa-0"><v-btn outline small class="red white--text"
          @click="selectedItems = []">Cancel Selection</v-btn>
        <v-btn small class="green white--text" @click="bumpOut()"><v-icon class="pr-2"
            small>flaticon-item-prepared</v-icon>Bump-out</v-btn></v-flex>
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text ref="check_cont" class="text--primary pa-0 ticket custom-scroll"
      :class="{ 'custom-scroll--lg': settings.increaseScrollWidth }">
      <v-list dense class="py-0">
        <v-list-tile v-if="check.sale_type > 4 && check.instruction">
          <v-list-tile-content class="body-1 primary--text">{{
            check.instruction
            }}</v-list-tile-content>
        </v-list-tile>
        <div v-for="(kot, kotInd) in lineItems" :key="`kot-group--${check.ticket_name}-${kot.kotNumber}`">
          <div class="kot-number table-header">
            Kot: {{ kot.kotNumber }}, Time: {{ kot.time }},
            {{
              kot.differentUsers
                ? `${kot.createdUserLabel}: ${kot.createdUserName}(${kot.userLabel}: ${kot.userName})`
                : `${kot.userLabel}: ${kot.userName}`
            }}
            <v-spacer></v-spacer>
            <timer :date="`${check.sale_open_date}`" :time="`${kot.time}`"
              @milli-seconds="updateTimeInMs($event, kotInd)"></timer>
          </div>
          <div v-for="item in kot.items"
            :key="`kot-group-items--${check.ticket_name}-${kot.kotNumber}-${item.item_number}`">
            <v-list-tile class="py-0" :class="{
              // 'py-2': item.modifier_receipe,
              'blue-grey white--text': item.fab,
              'selected-item': isItemSelected(item),
            }" @click="selectItems(item)">
              <v-list-tile-action class="subheading font-weight-bold item-qty--action">
                <!-- Additive: on a multi-portion line the quantity opens the
                     partial dialog. Every existing row action is untouched. -->
                <div class="item-qty" :class="{ 'item-qty--tappable': canPickQuantity(item) }"
                  :title="canPickQuantity(item) ? 'Tap to select quantity for Food Ready' : ''"
                  @click="onQtyClick($event, item)">
                  {{ item.quantity }}
                </div>
                <!-- Ready/total for the original line, next to the quantity, so
                     the split pair does not read as a duplicate KOT. -->
                <span v-if="readyProgress(item, kot.items)" class="caption green--text font-weight-bold">
                  {{ readyProgress(item, kot.items) }}
                </span>
              </v-list-tile-action>

              <v-list-tile-content class="subheading font-weight-bold">
                <!-- <div>{{ item.name }}</div> -->
                <!-- Adding ICON timer and KOT notes || 26-03-2026 -->
                <span>
                  <div  :class="[
                    !isItemSelected(item) ?'' : ''
                  ]">
                    {{ item.name }}
                     <v-icon class="py-n2 font-weight-bolder" v-if="isPrepTimeOver(item.preparation_time, differenceInMs[kotInd])" :class="[
                  !isItemSelected(item) ? GetPrepTimerColor(item.preparation_time, differenceInMs[kotInd]) : ''
                  ]">flaticon-auto-hold</v-icon>
                  </div>
                  <v-icon v-if="item.call_back_item_action" class="green--text ml-1" title="Item Restored"
                    small>undo</v-icon>
                </span>
                <span v-if="item.kot_instruction!==''" class="brown--text">
                  {{ item.kot_instruction }}
                  <v-icon  v-if="item.kot_instruction" small color="brown" class="mr-1">flaticon-notes</v-icon>
                </span>
                <!-- modifiers -->
                <div class="pink--text font-weight-bold" v-if="item.modifier_receipe">
                  <div v-for="modifier in deletedIncludedModifiers(
                    item.modifier_receipe
                  )" :key="modifier.id" class="strike--text error--text">
                    <span>{{ modifier.name }}</span>
                  </div>

                  <div v-for="modifier in selectedModifiers(item.modifier_receipe)" :key="modifier.id">
                    {{ modifier.name }}
                  </div>
                </div>

                <!-- instruction -->
                <div class="orange--text font-weight-bold" v-for="(instruction, idx) in item.instructions"
                  :key="`instruction-${idx}`">
                  -> {{ instruction }}
                </div>
              </v-list-tile-content>
              <!-- <v-list-tile-action class="font-weight-bold">
                <timer
                  :date="`${check.sale_open_date}`"
                  :time="`${item.kot_sent_time.slice(0, -3)}`"
                ></timer>
              </v-list-tile-action> -->

              <v-icon color="success" v-if="item.table_transfer"
                @click.stop="transferTable(item)">flaticon-transfer-table</v-icon>

              <v-list-tile-action>
                <action-btn :showServed="showServed" :item.sync="item" :act="act" :serve="true"></action-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider></v-divider>
          </div>
        </div>
      </v-list>
    </v-card-text>

    <check-details :show.sync="showCheckDetails" @close="showCheckDetails = $event" :check.sync="check"></check-details>
    <qty-picker :show.sync="showQtyPicker" :item="qtyPickerItem" :status="qtyPickerStatus"
      @select="onQtySelect"></qty-picker>
  </v-card>
</template>

<style slot-scope>
@media screen and (min-width: 625px) {
  .ticket {
    max-height: calc(50vh - 84px);
    overflow-y: auto;
  }
}

/* v-dialog leaves an inline-block placeholder where it is declared. The two
   dialogs at the end of this card therefore created a text line box, showing as
   a strip of empty space under the last item. Their content renders detached to
   [data-app], so the placeholders need no height -- block collapses them to 0. */
.check-card > .v-dialog__container {
  display: block;
}

/* home.vue wraps each card in <v-flex d-flex>, and v-layout stretches every
   item in a row to the height of the tallest. A ticket with fewer KOTs was
   padded out with dead space under its last item. Sizing to content instead
   ends the card where its items end. */
.check-card {
  align-self: flex-start;
}

.sale-view-activator {
  cursor: pointer;
  display: flex;
  padding: 10px 0;
  align-items: center;
  flex-wrap: wrap;
}

/* Reserve the timer's width (it is always a fixed HH:MM:SS) so that v-show
   hiding it cannot change how the title bar wraps. Without this, opening the
   action dial removed the timer from the layout, the bar un-wrapped, the action
   icon jumped up a line out from under the cursor, the dial closed, and the two
   states oscillated -- leaving the green button impossible to click. The timer
   itself still shows and hides exactly as before. */
.check-timer {
  display: inline-block;
  min-width: 8ch;
  text-align: right;
}

/* When the title bar wraps, this button lands alone on the next line, which
   starts at the left edge because the v-spacer was consumed on the line above.
   Its dial opens leftwards (direction="left", right: 100%), so from there the
   revealed buttons fall outside the card. Keeping it at the right of whichever
   line it lands on gives them room to open inside the card. */
.check-action {
  margin-left: auto;
}

.br-2 {
  border-radius: 2px;
}

.bg {
  background-color: #0f3d44 !important;
  color: white;
}

.hover-bg {
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
}

/* Wide enough for the 32px quantity control, plus a gap so the item name never
   sits flush against it. The original 28px assumed bare text, which left its own
   whitespace; the bordered control fills the cell edge to edge. */
.item-qty--action.v-list__tile__action {
  min-width: 32px !important;
  margin-right: 10px;
}

/* Sized to sit inside the original 40px row so row density is unchanged. */
.item-qty {
  min-width: 32px;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  touch-action: manipulation;
}

/* Same border idiom as .selected-item below, so the tappable quantity reads as
   part of the existing row vocabulary. */
.item-qty--tappable {
  cursor: pointer;
  border: 1px solid #ff9800;
  background-color: rgba(0, 0, 0, 0.04);
}

.item-qty--tappable:active {
  background-color: #fffbcc;
  color: black;
}

.theme--dark .item-qty--tappable {
  background-color: rgba(255, 255, 255, 0.08);
}

.cursor-pointer {
  cursor: pointer;
}

.ticket .v-list--dense .v-list__tile {
  min-height: 40px;
  height: auto !important;
}

.ticket .v-list__tile__action {
  min-width: auto;
  padding: 5px 0 !important;
}

.strike--text {
  text-decoration: line-through;
}

.kot-number {
  font-weight: 900;
  font-size: 12px;
  padding: 2px 8px;
  display: flex;
}

.selected-item {
  background-color: #fffbcc;
  border: 1px solid #ff9800;
  /* light green border */
  box-sizing: border-box;
  border-radius: 4px;
  /* optional: for rounded corners */
  color: black;
}
</style>

<script>
// import { requestInfo } from "@/providers/RoloProvider";
import actionBtn from "@/components/action";
import timer from "@/components/utils/timer";
import Mixin from "@/components/utils/mixin";
import checkDetails from "./checkDetails";
import qtyPicker from "@/components/qtyPicker";
import { getRowColor } from "@/helper/helper.js";
import { isPrepTimeOver } from "@/helper/helper.js";
import { GetPrepTimerColor } from "@/helper/helper.js";

export default {
  name: "check",
  mixins: [Mixin],
  props: {
    check: {
      type: Object,
      required: true
    },
    selectedItem: Number,
    search: {
      type: Object
    }
  },
  components: {
    "action-btn": actionBtn,
    timer,
    checkDetails,
    "qty-picker": qtyPicker
  },
  data() {
    return {
      fab: false,
      saleProps: {
        enable: false,
        check: {}
      },
      storeId: 0,
      showCheckDetails: false,
      showQtyPicker: false,
      qtyPickerItem: null,
      qtyPickerStatus: 4,
      enableUpArrow: false,
      enableDownArrow: true,
      scrollVal: 30,
      showScrollBtn: false,
      differenceInMs: [],
      getRowColor,
      selectedItems: [],
      isPrepTimeOver,
      GetPrepTimerColor
    };
  },
  watch: {
    lineItems(v) {
      this.differenceInMs = new Array(v.length);
    }
  },
  computed: {
    settings() {
      return this.$store.getters.nodeSettings;
    },
    lineItems() {
      let results = [];
      let res = new Map();
      this.check.items.forEach((item) => {
        const kotNumber = item.kot_number;
        if (res[kotNumber]) {
          res[kotNumber].items.push(item);
        } else {
          res[kotNumber] = {
            kotNumber,
            time: item.kot_sent_time,
            items: [item],
            userLabel: item.kot_user_id === -1 ? "Guest" : "Staff",
            userName: item.kot_user_name,
            differentUsers: item.kot_user_id != item.created_by,
            createdUserLabel: item.created_by === -1 ? "Guest" : "Staff",
            createdUserName: item.created_by_name
          };
        }
      });
      for (let kotNumber in res) {
        res[kotNumber].items = res[kotNumber].items.sort((a, b) => {
          const d1 = a.itemNumber;
          const d2 = b.itemNumber;
          if (d1 < d2) return 1;
          if (d1 > d2) return -1;
          return 0;
        });
        results.push(res[kotNumber]);
      }
      const sort = Number(this.search.sortOrder);
      return results.sort((a, b) => {
        const d1 = a.kotNumber;
        const d2 = b.kotNumber;
        if (d1 > d2) return sort;
        if (d1 < d2) return sort * -1;
        return 0;
      });
    },
    platform() {
      let vendor = "Online Order";
      if (this.check.sale_type == 5) vendor = "Zomato";
      if (this.check.sale_type == 6) vendor = "Swiggy";
      return vendor;
    },
    showTime() {
      let settings = this.$store.getters.nodeSettings;
      if (settings && settings.showTime) {
        if (!settings.showTime.value) return false;
      }
      return !this.preference.splitByKotNo;
    },
    showStoreName() {
      return this.$store.getters.showStoreName;
    },
    showServed() {
      return this.$store.getters.showServed;
    },
    settings() {
      return this.$store.getters.nodeSettings;
    },
    showScrollControls() {
      return this.settings.showScrollControls && this.showScrollBtn;
    },
    preference() {
      return this.$store.getters.getPreferences;
    },
  },
  methods: {
    transferTable(item) {
      let kitchenLine = JSON.parse(localStorage.getItem("kitchenLine"));

      this.$root.$confirm
        .open("Confirm", "Are you sure to transfer item?", {})
        .then((confirm) => {
          if (confirm) {
            this.tableTransfer(
              this.check.ticket_name,
              kitchenLine.id,
              item.item_number,
              confirm
            );
          }
          return;
        });
    },
    updateTimeInMs(v, index) {
      this.differenceInMs.splice(index, 1, v);
    },
    act(item, status, call_back_item, serveItem = false, quantity) {
      // Unchanged from the original flow. `quantity` is only ever supplied by
      // the quantity dialog; every action button reaches here directly.
      this.selectedItems = [];
      let kitchenLine = JSON.parse(localStorage.getItem("kitchenLine"));

      this.setItemStatus(
        this.check.ticket_name,
        kitchenLine.id,
        item,
        status,
        call_back_item,
        serveItem,
        quantity
      );
    },
    onQtySelect({ item, quantity }) {
      // Choosing the full quantity sends no quantity segment at all, so that
      // path stays byte-identical to the pre-existing whole-item request.
      this.act(item, this.qtyPickerStatus, false, false, quantity);
    },
    actOnCheck(check, status) {
      this.selectedItems = [];
      let kitchenLine = JSON.parse(localStorage.getItem("kitchenLine"));
      if (this.preference.splitByKotNo) {
        this.setCheckStatus(check, kitchenLine.id, status, true);
        return;
      }
      this.setCheckStatus(check, kitchenLine.id, status);
    },
    onScroll(evt) {
      let elem = this.$refs.check_cont;
      if (elem) {
        this.enableUpArrow = elem.scrollTop > 0;
        this.enableDownArrow =
          elem.scrollHeight > elem.scrollTop + elem.clientHeight;
      }
    },
    moveTo(px) {
      this.$nextTick(() => {
        let elem = this.$refs.check_cont;
        if (elem) {
          if (px > 0) {
            elem.scrollTop += px;
          } else {
            if (
              elem.scrollTop > this.scrollVal &&
              elem.scrollTop < this.scrollVal
            ) {
              elem.scrollTop = 0;
              return;
            }
            elem.scrollTop += px;
          }
        }
      });
    },
    selectItems(item) {
      console.log(item);
      const index = this.selectedItems.findIndex(
        (i) => i.item_number === item.item_number
      );

      if (index === -1) {
        this.selectedItems.push(item);
      } else {
        this.selectedItems.splice(index, 1);
      }
    },
    isItemSelected(item) {
      return this.selectedItems.some((i) => i.item_number === item.item_number);
    },
    bumpOut() {
      let itemIds = this.selectedItems.map((i) => i.item_uuid);
      let kitchenLine = JSON.parse(localStorage.getItem("kitchenLine"));

      this.setMultipleItemStatus(
        this.check.ticket_name,
        kitchenLine.id,
        itemIds,
        4
      );
      this.selectedItems = [];
    }
  },
  mounted() {
    let elem = this.$refs.check_cont;
    if (elem) {
      this.showScrollBtn = elem.scrollHeight > elem.clientHeight;
      elem.addEventListener("scroll", this.onScroll);
    }
  },
  created() {
    this.storeId = localStorage.getItem("storeId");
  }
};
</script>
